import { render, staticRenderFns } from "./hotel-results.vue?vue&type=template&id=7a081331&scoped=true"
import script from "./hotel-results.vue?vue&type=script&lang=js"
export * from "./hotel-results.vue?vue&type=script&lang=js"
import style0 from "./hotel-results.vue?vue&type=style&index=0&id=7a081331&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a081331",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppHeader: require('/home/forge/farescraper.com/components/AppHeader.vue').default,HomeHero: require('/home/forge/farescraper.com/components/HomeHero.vue').default,FlightsLoading: require('/home/forge/farescraper.com/components/FlightsLoading.vue').default,HotelsFilters: require('/home/forge/farescraper.com/components/HotelsFilters.vue').default,HotelsSortSelect: require('/home/forge/farescraper.com/components/HotelsSortSelect.vue').default,HotelsList: require('/home/forge/farescraper.com/components/HotelsList.vue').default,AppFooter: require('/home/forge/farescraper.com/components/AppFooter.vue').default,DebugBar: require('/home/forge/farescraper.com/components/DebugBar.vue').default})
